import { IListPrice } from "@/interfaces/list-price.interface";
import { ListPriceMessages } from "@/messages/listPrice/list-price.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { ListPriceFilterKey } from "./types";

export const initialFilterValues: IFilter<IListPrice>[] = [
  {
    property: "code",
    value: "",
    filterType: FilterType.Contains,
  },
];

export const LIST_PRICE_TABLE_COLUMNS = (messages: ListPriceMessages) => [
  messages.codeColumn,
  messages.titleColumn,
  messages.eanColumn,
  messages.variationColumn,
  messages.priceColumn,
  messages.promotionStartDateColumn,
  messages.promotionFinalDateColumn,
  messages.promotionPriceColumn,
  messages.statusColumn,
  messages.optionsColumn,
];

export const FILTER_ATTRIBUTES: Partial<Record<ListPriceFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  code: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  active: {
    defaultValue: true,
    type: FilterType.Equals,
    valueType: "boolean",
  },
  title: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  ean: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};

export const FILTER_OPTIONS = (messages: ListPriceMessages): SelectData<ListPriceFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.codeOption, value: "code" },
  { label: messages.titleOption, value: "title" },
  { label: messages.eanOption, value: "ean" },
  { label: messages.statusOption, value: "active" },
];

export const FILTER_OPTION_VALUES = (
  messages: ListPriceMessages
): Partial<Record<ListPriceFilterKey, SelectData<FilterValue>[]>> => ({
  code: [],
  active: STATUS_OPTIONS(messages),
  title: [],
  ean: [],
});

export const STATUS_OPTIONS = (messages: ListPriceMessages): SelectData<boolean>[] => [
  { label: messages.statusTrueOption, value: true },
  { label: messages.statusFalseOption, value: false },
];
